const pipControlTemplate = ({accessBtnPip, pipButtonIndex}) => `<button name="PIP" type="button" role="button" aria-pressed="false" class="ui control-button tertiary-button pip-button" title="${accessBtnPip}" tabindex="${pipButtonIndex}">
   <span class="ui pip-button-glyph"></span>
</button>`;

export default pipControlTemplate;
